<template>
    <v-row no-gutters class="fill-height" align-content="space-between">
        <v-col cols="12">
            <DataTable
                title="Transactions"
                :headers="PublicTransaction.headers()"
                :model-class="PublicTransaction"
                :items="page.props.data"
                :search-endpoint="() => useRoute().build(PublicTransaction.routes().index)"
                :crud-config="{
                    showCreateAction: false,
                    showUpdateAction: false,
                    showDeleteAction: false,
                    showViewAction: true,
                    showCustomAction: false,
                }"
                :config="useConfig().publicTransaction"
                :show-breadcrumbs="false"
            >
                <template #intro>
                    <v-row  justify="center" class="mt-5">
                        <v-col cols="12" sm="5" md="2">
                            <v-img src="@shared/assets/images/cb-logo-green.png" class="" />
                        </v-col>

                        <v-col md="7" lg="5" xl="4">
                            <v-row>
                                <v-col class="mt-5">
                                    <p style="font-size: medium; text-align-last: start"><strong>The Carbono Biodiverso Registry</strong> is the backbone of our carbon program, ensuring <strong>accountability</strong>, <strong>integrity</strong>, and <strong>transparency</strong>. This public record shows all carbon offset transactions under <strong>Grupo Ecológico Sierra Gorda</strong>, guided by the Local Protocol for <strong>Subnational Forest Regeneration</strong>.</p>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn rounded variant="outlined" to="https://carbonobiodiverso.net/" target="_blank">Learn about the protocol</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="mb-2">
                        <v-col cols="auto">
                            <p>Hover over the <v-icon color="primary" icon="mdi-information"/> for explanation</p>
                        </v-col>
                    </v-row>
                </template>
            </DataTable>
        </v-col>
        <v-col cols="12">
            <ThePublicRegistryFooter />
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { PublicTransaction } from '@app/purchase/transaction/models/PublicTransaction';
import { useConfig } from '@shared/composables/useConfig';
import { useRoute } from '@shared/composables/useRoute';

const page = PublicTransaction.routes().index.page;
</script>
